import { graphql } from 'react-apollo';
import { USER_QUERY } from './graphql/queries';

export const getUserData = (operationOptions = {}) => {
  return graphql(USER_QUERY, operationOptions);
};



// WEBPACK FOOTER //
// ./src/utils/graphQLFunctions.js